import { Card, Heading, Layout, Page, TextContainer } from "@shopify/polaris";

export default function PageName() {
  return (
    <Page>
      <ui-title-bar title="Page name">
        <button variant="primary" onClick={() => { }}>Primary action</button>
        <button onClick={() => { }}>Secondary action</button>
      </ui-title-bar>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <Heading>Heading</Heading>
            <TextContainer>
              <p>Body</p>
            </TextContainer>
          </Card>
          <Card sectioned>
            <Heading>Heading</Heading>
            <TextContainer>
              <p>Body</p>
            </TextContainer>
          </Card>
        </Layout.Section>
        <Layout.Section secondary>
          <Card sectioned>
            <Heading>Heading</Heading>
            <TextContainer>
              <p>Body</p>
            </TextContainer>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
